
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'universal-recording-review-public-ui',
  currentProjectVersion: 'static-1.912',
  depVersions: {
  "universal-recording-review-public-ui": "static-1.912",
  "client-types": "static-1.490",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8272",
  "hubspot-dlb": "static-2.1882",
  "jasmine": "static-4.4563",
  "jasmine-runner": "static-1.6694",
  "react-dlb": "static-1.84",
  "reselect": "static-3.9",
  "video-components-external": "static-1.12050",
  "webpack-env": "static-1.54",
  "calling-orchestration-shared-library": "static-1.36455",
  "data-fetching-client": "static-1.9902",
  "external-sharing-components": "static-1.1089",
  "file-manager-components": "static-1.24357",
  "foundations-components": "static-1.8381",
  "hub-http": "static-1.6457",
  "hubspot-url-utils": "static-1.4297",
  "I18n": "static-7.1661",
  "object-comments-thread-lib": "static-1.11258",
  "prosemirror-user-and-team-at-mentions": "static-1.1109",
  "purchase-motions-components": "static-1.6280",
  "quartz-config": "static-1.1141",
  "quartz-core": "static-1.6582",
  "quartz-routing": "static-1.793",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-colorpicker": "static-2.10452",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16953",
  "recording-review-components-lib": "static-1.33480",
  "rpc-client-utils": "static-1.4908",
  "ui-addon-upgrades": "static-9.18318",
  "UIComponents": "static-3.8675",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3640",
  "quartz-webpack": "static-1.3587",
  "bend-plugin-quartz-routing": "static-1.441",
  "HeadJS": "static-2.789",
  "quartz": "static-1.7363",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3383",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4902",
  "apollo-stack-hubspot": "static-3.90",
  "content-media-composition-data-lib": "static-1.13105",
  "content-media-compositions": "static-2.17112",
  "foundations-assets": "static-1.5122",
  "foundations-theming": "static-1.4700",
  "graphql": "static-1.86",
  "HubStyleTokens": "static-2.11729",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4397",
  "magpie-lib": "static-1.5718",
  "magpie-types": "static-1.5178",
  "media-bridge-lib": "static-1.19334",
  "quick-fetch": "static-1.4091",
  "react-utils": "static-2.5514",
  "ts-schema": "static-1.4253",
  "video-data-lib": "static-1.35708",
  "ai-components-ui-library": "static-1.9578",
  "calling-orchestration-schema": "static-1.36680",
  "conversations-skeleton-state": "static-1.7494",
  "crm-links": "static-1.6568",
  "crm-message-bus": "static-1.43634",
  "customer-data-objects": "static-1.7932",
  "frontend-preferences-client": "static-1.8173",
  "onboarding-scopes": "static-1.6704",
  "quartz-i18n": "static-1.1038",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11391",
  "usage-based-billing-components-lib": "static-1.10029",
  "usage-tracker": "static-1.7602",
  "usage-tracker-core": "static-1.7452",
  "voice-sms-access-library": "static-1.1903",
  "fast-json-stable-stringify": "static-1.4",
  "sanitize-text": "static-1.8395",
  "breeze-engine-lib": "static-1.1562",
  "copilot-toolkit": "static-1.11739",
  "StyleGuideUI": "static-3.495",
  "ui-addon-iframeable": "static-1.9322",
  "bend-plugin-foundations-components": "static-1.4650",
  "floating-ui": "static-1.61",
  "foundations-theming-specialty": "static-1.2416",
  "hs-story-utils": "static-1.9671",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.60",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2460",
  "ui-fonts": "static-1.991",
  "ui-images": "static-2.1229",
  "hs-locale-management": "static-1.254",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "avatar-components": "static-1.2742",
  "call-summary": "static-1.40052",
  "content-assistance-lib": "static-1.8129",
  "cssUtils": "static-1.869",
  "customer-data-reference-ui-components": "static-1.13425",
  "customer-data-ui-utilities": "static-1.10071",
  "hs-lodash": "static-4.45",
  "hubspot-prosemirror": "static-1.18866",
  "HubStyle": "static-2.12036",
  "prosemirror": "static-1.13",
  "reference-resolvers-lite": "static-1.8345",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10669",
  "transmute": "static-2.85",
  "ui-shepherd-react": "static-3.10509",
  "foundations-components-legacy": "static-1.1406",
  "hub-http-shared-msw-handlers": "static-1.10523",
  "merchandise-lib": "static-1.273",
  "purchase-motions-api": "static-1.6283",
  "signup-constants": "static-1.19486",
  "signup-ui-url-generator": "static-2.8306",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.867",
  "hubspotter-http": "static-1.4823",
  "icons": "static-2.674",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1038",
  "quartz-head": "static-1.1028",
  "quartz-test": "static-1.1038",
  "quartz-tracking": "static-1.742",
  "trellis-components": "static-1.2479",
  "usage-tracker-container": "static-1.7592",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "tanstack-virtual": "static-1.36",
  "bend-plugin-chirp-manifest": "static-1.318",
  "chirp-fetch": "static-1.2134",
  "atom": "static-1.5327",
  "laboratory-lib": "static-3.7397",
  "react-input-autosize": "static-2.17",
  "salesImages": "static-1.530",
  "bender-build-tools": "static-1.3373",
  "js-cookie": "static-1.18",
  "bend-plugin-foundations-theming": "static-1.3183",
  "foundations-theming-base": "static-1.3685",
  "stylex": "static-1.38",
  "reactive-lib": "static-1.967",
  "simple-logging-lib": "static-1.3294",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22625",
  "ContentUtils": "static-1.69052",
  "customer-data-objects-ui-components": "static-1.13276",
  "sanitize": "static-1.4721",
  "sassPrefix": "static-1.161",
  "seat-types-lib": "static-1.605",
  "framework-data-schema-resolvers": "static-1.7139",
  "location-customization-utils-lib": "static-1.9985",
  "restore-request-side-panel-lib": "static-1.1549",
  "inbound-db-properties-service-client": "static-1.4017",
  "property-translator": "static-1.5639",
  "foundations-components-test-utils": "static-1.5864",
  "customer-data-property-utils": "static-1.8344",
  "highcharts": "static-8.108",
  "onboarding-tours": "static-1.17036",
  "onboarding-tours-client": "static-1.5250",
  "one-click-checkout": "static-1.305",
  "platform-infra-nav-components": "static-1.7846",
  "reporting-ui-components": "static-2.65840",
  "reporting-visualizations": "static-1.60645",
  "subscription-experience-data-types": "static-1.15195",
  "breeze-engine-chat-components": "static-1.540",
  "breeze-engine-core": "static-1.840",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "superstore": "static-1.5003",
  "navigation-messaging": "static-1.8037",
  "ai-addon-copilot-preview": "static-1.8790",
  "calling-cross-tab-library": "static-1.19538",
  "calling-error-reporting": "static-1.31568",
  "calling-internal-common": "static-1.31561",
  "calling-lifecycle-internal": "static-1.66744",
  "calling-lifecycle-usage-tracker": "static-1.9305",
  "wootric-nps": "static-1.7159",
  "ui-addon-video-player": "static-1.8950",
  "ui-coaching-tips": "static-1.29210",
  "PatternValidationJS": "static-1.3142",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.8428",
  "hs-promise-utils": "static-1.5841",
  "react-dnd-compat": "static-1.4861",
  "react-immutable-render-mixin": "static-1.9",
  "content-media-capture": "static-1.5301",
  "emoji-mart": "static-3.4",
  "growth-payments-core": "static-1.26069",
  "knowledge-content-types": "static-1.8618",
  "payment-link-components": "static-1.24074",
  "rich-text-lib": "static-1.20233",
  "ui-addon-emoji-picker": "static-1.10131",
  "ui-business-units-lib": "static-1.9327",
  "batch-promise": "static-1.1790",
  "external-options-client-types": "static-1.4300",
  "hubspotter-http-shared-msw-handlers": "static-1.10521",
  "usage-tracker-session-replay": "static-1.5288",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1206",
  "cms-field-types": "static-1.5060",
  "content-icons-ui": "static-1.2309",
  "integrations-lib": "static-1.16923",
  "underscore": "static-1.8",
  "conditional-properties-service-client": "static-1.3973",
  "crm-pipelines-api-client-types": "static-1.4307",
  "fdsr-migration-layer": "static-1.258",
  "framework-builder-read-service-client": "static-1.4180",
  "framework-data-schema-quick-fetch": "static-1.7044",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3867",
  "persist-promise": "static-1.3947",
  "crm-record-cards-service-types": "static-1.3755",
  "getting-started-shared-tasks": "static-1.19109",
  "growth-data-modal": "static-1.5815",
  "growth-onboarding-confetti": "static-1.3306",
  "growth-onboarding-next-action-utils": "static-1.2592",
  "navigation-components": "static-1.18710",
  "onboarding-tours-utils": "static-1.1102",
  "ui-shepherd-tracker": "static-1.7890",
  "ui-universal-auth": "static-1.9282",
  "user-context": "static-1.5357",
  "checkout-sdk": "static-3.24243",
  "payment-method-components": "static-1.7094",
  "touchless-buying-components": "static-1.6111",
  "upgrade-catalog-service-types": "static-1.3730",
  "reporting-action-components": "static-1.41905",
  "reporting-data": "static-1.68569",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68247",
  "reporting-snowflake": "static-1.57187",
  "edison-service-client-types": "static-1.635",
  "breeze-artifacts-sdk": "static-1.179",
  "ably-hubspot-js": "static-2.4966",
  "ai-rendering-library": "static-1.10998",
  "ai-settings-ui-library": "static-1.8253",
  "copilot-plugins": "static-1.11711",
  "pulse": "static-1.872",
  "shared-worker-versioning": "static-1.11286",
  "calling-usage-tracker": "static-1.6784",
  "customer-data-tracking": "static-1.7127",
  "growth-onboarding-feedback-components": "static-1.6828",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4670",
  "ui-addon-opt": "static-4.8608",
  "commerce-tours-lib": "static-1.6532",
  "customer-data-properties": "static-1.52423",
  "growth-onboarding-reliability": "static-1.5325",
  "sales-checkout-service-client": "static-1.3779",
  "data-token-picker": "static-1.16813",
  "FileManagerLib": "static-1.39997",
  "redux-thunk": "static-2.77",
  "amplitude-session-replay-browser": "static-1.60",
  "flux-actions": "static-1.360",
  "hubspot-apollo-client": "static-1.5124",
  "integrations-error-boundary-lib": "static-1.14338",
  "integrations-tracking-lib": "static-1.5853",
  "native-integrations-shared-strings": "static-1.8022",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10611",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.796",
  "onboarding-data-sync-lib": "static-1.2394",
  "growth-onboarding-next-action-components": "static-1.2620",
  "user-context-client": "static-1.4754",
  "nest": "static-1.482",
  "unified-auth-core-lib": "static-1.1078",
  "getting-started-shared-tasks-store": "static-1.18227",
  "hub-http-rxjs": "static-1.832",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4237",
  "company-details-components": "static-1.6445",
  "emoji-regex": "static-1.7",
  "final-form": "static-1.75",
  "react-performance-metrics-lib": "static-1.800",
  "pricing-pages-ui-components": "static-1.15491",
  "quote-checkout-service-types": "static-1.3700",
  "dashboard-lib": "static-1.82622",
  "ExportDialog": "static-6.10626",
  "hubspot-prosemirror-plugins": "static-1.18858",
  "share-with-third-party-component-lib": "static-1.8949",
  "ui-addon-draggable": "static-3.5002",
  "ui-asset-management-lib": "static-1.11342",
  "reporting-client-types": "static-1.2650",
  "campaign-roi-lib": "static-1.9988",
  "ui-addon-calendars": "static-2.5571",
  "customer-data-filters-ui": "static-1.40748",
  "reporting-datasets-permissions-lib": "static-1.14362",
  "breeze-onboarding-components": "static-1.607",
  "embedded-academy-lib": "static-1.15338",
  "mermaid": "static-1.3",
  "trial-components-library": "static-1.14018",
  "ui-addon-teams": "static-1.21852",
  "upgrade-components-lib": "static-1.453",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3433",
  "ui-addon-react-router-dom": "static-1.9779",
  "ui-brand-identity-lib": "static-1.16215",
  "bend-plugin-pulse": "static-1.375",
  "event-emitter": "static-1.1199",
  "fast-json-patch": "static-1.67",
  "feedback-loader": "static-1.29733",
  "commerce-products-lib": "static-1.10401",
  "calling-global-api": "static-1.65362",
  "calling-lifecycle-messages": "static-1.59038",
  "crm-index-visualization-core": "static-1.4471",
  "customer-data-properties-shared-msw-handlers": "static-1.9850",
  "formula-editor": "static-1.14673",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.433",
  "inbounddb-objects-service-types": "static-1.4385",
  "meetings-icalendar-utils-lib": "static-1.881",
  "object-builder-ui-client": "static-1.49523",
  "pipeline-validation-client-types": "static-1.4142",
  "property-value-citations": "static-1.3037",
  "smart-property-lib": "static-1.8163",
  "tiered-pricing": "static-1.1855",
  "topics-actions-lib": "static-1.405",
  "ui-addon-form-validation": "static-1.11231",
  "zustand": "static-1.79",
  "audio-components": "static-1.6271",
  "FileManagerCore": "static-1.39856",
  "FileManagerImages": "static-1.37508",
  "video-components": "static-1.14052",
  "hubspot-apollo-cache": "static-1.583",
  "universal-page-editor-lib": "static-1.3255",
  "adobe-sign-auth-lib": "static-1.349",
  "ads-unified-auth-lib": "static-1.1026",
  "google-sheets-integration-lib": "static-1.925",
  "microsoft-drive-auth-lib": "static-1.15",
  "surveymonkey-integration-lib": "static-1.370",
  "slack-ui-library": "static-1.10642",
  "InboxConnectUtils": "static-4.15455",
  "meetings-connect-utils-lib": "static-1.7853",
  "fsm": "static-1.3985",
  "company-details-service-types": "static-1.4185",
  "segments-query-core": "static-1.1669",
  "pricing-pages-api": "static-1.15356",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24911",
  "viral-links-lib": "static-1.7320",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.479",
  "timezone-utils": "static-2.5492",
  "customer-data-filters-ui-msw-helpers": "static-1.23184",
  "events-data-lib": "static-1.489",
  "FormUrlGenerator": "static-2.4971",
  "multi-account-reference-resolvers": "static-1.1242",
  "onboarding-journeys-lib": "static-1.768",
  "academy-common-lib": "static-1.14798",
  "hubs-service-types": "static-1.1502",
  "ContentData": "static-1.69127",
  "commerce-permissions": "static-1.1022",
  "products-iframe-lib": "static-1.8492",
  "products-ui-components-shared-msw-handlers": "static-1.10905",
  "crm-index-associations-lib": "static-1.6687",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10606",
  "sales-views-client-types": "static-1.4503",
  "bark-lib": "static-1.16751",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6135",
  "react-codemirror": "static-1.10885",
  "data-agent-kit": "static-1.572",
  "policy-lib": "static-1.7040",
  "react-tinymce": "static-1.55871",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54997",
  "tinymce-plugins": "static-1.58111",
  "tinymce-themes": "static-1.56967",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4778",
  "video-embed": "static-1.36542",
  "social-insights-client-types": "static-1.22685",
  "hub-http-contrib": "static-1.3284",
  "ui-addon-sales-email": "static-1.5459",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22081",
  "sales-email-signature-service-client": "static-1.4090",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.420",
  "academy-service-client": "static-1.3936",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4649",
  "trellis-ecosystem": "static-1.7554",
  "advanced-menus-core": "static-1.15510",
  "advanced-menus-lib": "static-1.12391",
  "ui-memberships-settings-lib": "static-1.34705",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16261",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4755",
  "storybook-react": "static-1.37",
  "interframe": "static-3.5002",
  "tinymce-data": "static-1.41082",
  "layout-dnd-components": "static-1.12890",
  "layout-dnd-utils": "static-1.11865",
  "NamespacedHubStyle": "static-2.9222",
  "outpost": "static-1.4407",
  "marketplace-ui-apps-core": "static-1.19126",
  "marketplace-ui-common": "static-1.20594",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15509",
  "simple-menus-lib": "static-1.17026",
  "layout-data-lib": "static-1.10190",
  "developer-experience-shared-components": "static-1.10745",
  "immutable-less": "static-1.4896",
  "marketplace-ui-client-types": "static-1.18001",
  "ui-addon-integrations-directory-panel": "static-2.8271",
  "ui-extensibility-client-types": "static-1.4165",
  "nav-meta": "static-1.30347",
  "ui-product-approvals-common": "static-1.879",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4500"
},
  depPathPrefixes: {
  "universal-recording-review-public-ui": "/universal-recording-review-public-ui/static-1.912",
  "client-types": "/client-types/static-1.490",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8272",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "jasmine": "/jasmine/static-4.4563",
  "jasmine-runner": "/jasmine-runner/static-1.6694",
  "react-dlb": "/react-dlb/static-1.84",
  "reselect": "/reselect/static-3.9",
  "video-components-external": "/video-components-external/static-1.12050",
  "webpack-env": "/webpack-env/static-1.54",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36455",
  "data-fetching-client": "/data-fetching-client/static-1.9902",
  "external-sharing-components": "/external-sharing-components/static-1.1089",
  "file-manager-components": "/file-manager-components/static-1.24357",
  "foundations-components": "/foundations-components/static-1.8381",
  "hub-http": "/hub-http/static-1.6457",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "I18n": "/I18n/static-7.1661",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11258",
  "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1109",
  "purchase-motions-components": "/purchase-motions-components/static-1.6280",
  "quartz-config": "/quartz-config/static-1.1141",
  "quartz-core": "/quartz-core/static-1.6582",
  "quartz-routing": "/quartz-routing/static-1.793",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-colorpicker": "/react-colorpicker/static-2.10452",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16953",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.33480",
  "rpc-client-utils": "/rpc-client-utils/static-1.4908",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18318",
  "UIComponents": "/UIComponents/static-3.8675",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3640",
  "quartz-webpack": "/quartz-webpack/static-1.3587",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.441",
  "HeadJS": "/HeadJS/static-2.789",
  "quartz": "/quartz/static-1.7363",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3383",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4902",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13105",
  "content-media-compositions": "/content-media-compositions/static-2.17112",
  "foundations-assets": "/foundations-assets/static-1.5122",
  "foundations-theming": "/foundations-theming/static-1.4700",
  "graphql": "/graphql/static-1.86",
  "HubStyleTokens": "/HubStyleTokens/static-2.11729",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4397",
  "magpie-lib": "/magpie-lib/static-1.5718",
  "magpie-types": "/magpie-types/static-1.5178",
  "media-bridge-lib": "/media-bridge-lib/static-1.19334",
  "quick-fetch": "/quick-fetch/static-1.4091",
  "react-utils": "/react-utils/static-2.5514",
  "ts-schema": "/ts-schema/static-1.4253",
  "video-data-lib": "/video-data-lib/static-1.35708",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9578",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36680",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7494",
  "crm-links": "/crm-links/static-1.6568",
  "crm-message-bus": "/crm-message-bus/static-1.43634",
  "customer-data-objects": "/customer-data-objects/static-1.7932",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8173",
  "onboarding-scopes": "/onboarding-scopes/static-1.6704",
  "quartz-i18n": "/quartz-i18n/static-1.1038",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11391",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10029",
  "usage-tracker": "/usage-tracker/static-1.7602",
  "usage-tracker-core": "/usage-tracker-core/static-1.7452",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1903",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "sanitize-text": "/sanitize-text/static-1.8395",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1562",
  "copilot-toolkit": "/copilot-toolkit/static-1.11739",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9322",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4650",
  "floating-ui": "/floating-ui/static-1.61",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2416",
  "hs-story-utils": "/hs-story-utils/static-1.9671",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2460",
  "ui-fonts": "/ui-fonts/static-1.991",
  "ui-images": "/ui-images/static-2.1229",
  "hs-locale-management": "/hs-locale-management/static-1.254",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "avatar-components": "/avatar-components/static-1.2742",
  "call-summary": "/call-summary/static-1.40052",
  "content-assistance-lib": "/content-assistance-lib/static-1.8129",
  "cssUtils": "/cssUtils/static-1.869",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13425",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10071",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18866",
  "HubStyle": "/HubStyle/static-2.12036",
  "prosemirror": "/prosemirror/static-1.13",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8345",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10669",
  "transmute": "/transmute/static-2.85",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10509",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1406",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10523",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-api": "/purchase-motions-api/static-1.6283",
  "signup-constants": "/signup-constants/static-1.19486",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8306",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "hubspotter-http": "/hubspotter-http/static-1.4823",
  "icons": "/icons/static-2.674",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1038",
  "quartz-head": "/quartz-head/static-1.1028",
  "quartz-test": "/quartz-test/static-1.1038",
  "quartz-tracking": "/quartz-tracking/static-1.742",
  "trellis-components": "/trellis-components/static-1.2479",
  "usage-tracker-container": "/usage-tracker-container/static-1.7592",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.318",
  "chirp-fetch": "/chirp-fetch/static-1.2134",
  "atom": "/atom/static-1.5327",
  "laboratory-lib": "/laboratory-lib/static-3.7397",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "salesImages": "/salesImages/static-1.530",
  "bender-build-tools": "/bender-build-tools/static-1.3373",
  "js-cookie": "/js-cookie/static-1.18",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3183",
  "foundations-theming-base": "/foundations-theming-base/static-1.3685",
  "stylex": "/stylex/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.967",
  "simple-logging-lib": "/simple-logging-lib/static-1.3294",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22625",
  "ContentUtils": "/ContentUtils/static-1.69052",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13276",
  "sanitize": "/sanitize/static-1.4721",
  "sassPrefix": "/sassPrefix/static-1.161",
  "seat-types-lib": "/seat-types-lib/static-1.605",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7139",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9985",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1549",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4017",
  "property-translator": "/property-translator/static-1.5639",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5864",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8344",
  "highcharts": "/highcharts/static-8.108",
  "onboarding-tours": "/onboarding-tours/static-1.17036",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5250",
  "one-click-checkout": "/one-click-checkout/static-1.305",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7846",
  "reporting-ui-components": "/reporting-ui-components/static-2.65840",
  "reporting-visualizations": "/reporting-visualizations/static-1.60645",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15195",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.540",
  "breeze-engine-core": "/breeze-engine-core/static-1.840",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "superstore": "/superstore/static-1.5003",
  "navigation-messaging": "/navigation-messaging/static-1.8037",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8790",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19538",
  "calling-error-reporting": "/calling-error-reporting/static-1.31568",
  "calling-internal-common": "/calling-internal-common/static-1.31561",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66744",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9305",
  "wootric-nps": "/wootric-nps/static-1.7159",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8950",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29210",
  "PatternValidationJS": "/PatternValidationJS/static-1.3142",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.8428",
  "hs-promise-utils": "/hs-promise-utils/static-1.5841",
  "react-dnd-compat": "/react-dnd-compat/static-1.4861",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "content-media-capture": "/content-media-capture/static-1.5301",
  "emoji-mart": "/emoji-mart/static-3.4",
  "growth-payments-core": "/growth-payments-core/static-1.26069",
  "knowledge-content-types": "/knowledge-content-types/static-1.8618",
  "payment-link-components": "/payment-link-components/static-1.24074",
  "rich-text-lib": "/rich-text-lib/static-1.20233",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10131",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9327",
  "batch-promise": "/batch-promise/static-1.1790",
  "external-options-client-types": "/external-options-client-types/static-1.4300",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10521",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5288",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1206",
  "cms-field-types": "/cms-field-types/static-1.5060",
  "content-icons-ui": "/content-icons-ui/static-1.2309",
  "integrations-lib": "/integrations-lib/static-1.16923",
  "underscore": "/underscore/static-1.8",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3973",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4307",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.258",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4180",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7044",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3867",
  "persist-promise": "/persist-promise/static-1.3947",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3755",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19109",
  "growth-data-modal": "/growth-data-modal/static-1.5815",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3306",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2592",
  "navigation-components": "/navigation-components/static-1.18710",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1102",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7890",
  "ui-universal-auth": "/ui-universal-auth/static-1.9282",
  "user-context": "/user-context/static-1.5357",
  "checkout-sdk": "/checkout-sdk/static-3.24243",
  "payment-method-components": "/payment-method-components/static-1.7094",
  "touchless-buying-components": "/touchless-buying-components/static-1.6111",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3730",
  "reporting-action-components": "/reporting-action-components/static-1.41905",
  "reporting-data": "/reporting-data/static-1.68569",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68247",
  "reporting-snowflake": "/reporting-snowflake/static-1.57187",
  "edison-service-client-types": "/edison-service-client-types/static-1.635",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.179",
  "ably-hubspot-js": "/ably-hubspot-js/static-2.4966",
  "ai-rendering-library": "/ai-rendering-library/static-1.10998",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8253",
  "copilot-plugins": "/copilot-plugins/static-1.11711",
  "pulse": "/pulse/static-1.872",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11286",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6784",
  "customer-data-tracking": "/customer-data-tracking/static-1.7127",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6828",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4670",
  "ui-addon-opt": "/ui-addon-opt/static-4.8608",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6532",
  "customer-data-properties": "/customer-data-properties/static-1.52423",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5325",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3779",
  "data-token-picker": "/data-token-picker/static-1.16813",
  "FileManagerLib": "/FileManagerLib/static-1.39997",
  "redux-thunk": "/redux-thunk/static-2.77",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "flux-actions": "/flux-actions/static-1.360",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5124",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14338",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5853",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8022",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10611",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.796",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2394",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2620",
  "user-context-client": "/user-context-client/static-1.4754",
  "nest": "/nest/static-1.482",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1078",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18227",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.832",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4237",
  "company-details-components": "/company-details-components/static-1.6445",
  "emoji-regex": "/emoji-regex/static-1.7",
  "final-form": "/final-form/static-1.75",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.800",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15491",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3700",
  "dashboard-lib": "/dashboard-lib/static-1.82622",
  "ExportDialog": "/ExportDialog/static-6.10626",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18858",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8949",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5002",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11342",
  "reporting-client-types": "/reporting-client-types/static-1.2650",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9988",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5571",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40748",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14362",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.607",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15338",
  "mermaid": "/mermaid/static-1.3",
  "trial-components-library": "/trial-components-library/static-1.14018",
  "ui-addon-teams": "/ui-addon-teams/static-1.21852",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.453",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3433",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9779",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16215",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.375",
  "event-emitter": "/event-emitter/static-1.1199",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "feedback-loader": "/feedback-loader/static-1.29733",
  "commerce-products-lib": "/commerce-products-lib/static-1.10401",
  "calling-global-api": "/calling-global-api/static-1.65362",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59038",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4471",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9850",
  "formula-editor": "/formula-editor/static-1.14673",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.433",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4385",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.881",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49523",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4142",
  "property-value-citations": "/property-value-citations/static-1.3037",
  "smart-property-lib": "/smart-property-lib/static-1.8163",
  "tiered-pricing": "/tiered-pricing/static-1.1855",
  "topics-actions-lib": "/topics-actions-lib/static-1.405",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11231",
  "zustand": "/zustand/static-1.79",
  "audio-components": "/audio-components/static-1.6271",
  "FileManagerCore": "/FileManagerCore/static-1.39856",
  "FileManagerImages": "/FileManagerImages/static-1.37508",
  "video-components": "/video-components/static-1.14052",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.583",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3255",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.349",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1026",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.925",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.15",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.370",
  "slack-ui-library": "/slack-ui-library/static-1.10642",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15455",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7853",
  "fsm": "/fsm/static-1.3985",
  "company-details-service-types": "/company-details-service-types/static-1.4185",
  "segments-query-core": "/segments-query-core/static-1.1669",
  "pricing-pages-api": "/pricing-pages-api/static-1.15356",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24911",
  "viral-links-lib": "/viral-links-lib/static-1.7320",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.479",
  "timezone-utils": "/timezone-utils/static-2.5492",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23184",
  "events-data-lib": "/events-data-lib/static-1.489",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4971",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1242",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.768",
  "academy-common-lib": "/academy-common-lib/static-1.14798",
  "hubs-service-types": "/hubs-service-types/static-1.1502",
  "ContentData": "/ContentData/static-1.69127",
  "commerce-permissions": "/commerce-permissions/static-1.1022",
  "products-iframe-lib": "/products-iframe-lib/static-1.8492",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10905",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6687",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10606",
  "sales-views-client-types": "/sales-views-client-types/static-1.4503",
  "bark-lib": "/bark-lib/static-1.16751",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6135",
  "react-codemirror": "/react-codemirror/static-1.10885",
  "data-agent-kit": "/data-agent-kit/static-1.572",
  "policy-lib": "/policy-lib/static-1.7040",
  "react-tinymce": "/react-tinymce/static-1.55871",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54997",
  "tinymce-plugins": "/tinymce-plugins/static-1.58111",
  "tinymce-themes": "/tinymce-themes/static-1.56967",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4778",
  "video-embed": "/video-embed/static-1.36542",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "hub-http-contrib": "/hub-http-contrib/static-1.3284",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5459",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22081",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4090",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.420",
  "academy-service-client": "/academy-service-client/static-1.3936",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4649",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7554",
  "advanced-menus-core": "/advanced-menus-core/static-1.15510",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12391",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34705",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16261",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4755",
  "storybook-react": "/storybook-react/static-1.37",
  "interframe": "/interframe/static-3.5002",
  "tinymce-data": "/tinymce-data/static-1.41082",
  "layout-dnd-components": "/layout-dnd-components/static-1.12890",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11865",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9222",
  "outpost": "/outpost/static-1.4407",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19126",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20594",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15509",
  "simple-menus-lib": "/simple-menus-lib/static-1.17026",
  "layout-data-lib": "/layout-data-lib/static-1.10190",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10745",
  "immutable-less": "/immutable-less/static-1.4896",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18001",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8271",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4165",
  "nav-meta": "/nav-meta/static-1.30347",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.879",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4500"
}
};
